export type Listing = {
  id: string;
  title: string;
  tier: "Base" | "Featured" | "Top";
  status: "Published" | "Awaiting approval";
  location: string;
  price: string;
  length: string;
  year: number;
  summary: string;
};

export type Message = {
  id: string;
  listingId: string;
  sender: string;
  email: string;
  body: string;
  status: "pending" | "delivered" | "failed";
  notifiedAt: string;
  readAt?: string | null;
};

export const listings: Listing[] = [
  {
    id: "lagoon-42",
    title: "2021 Lagoon 42",
    tier: "Featured",
    status: "Published",
    location: "Barcelona, ES",
    price: "€590,000",
    length: "42 ft",
    year: 2021,
    summary: "Cruising catamaran with spacious salon and recent electronics.",
  },
  {
    id: "axopar-37",
    title: "2019 Axopar 37",
    tier: "Top",
    status: "Published",
    location: "Helsinki, FI",
    price: "€310,000",
    length: "37 ft",
    year: 2019,
    summary: "Fast commuter with twin outboards and upgraded nav suite.",
  },
  {
    id: "oceanis-38",
    title: "Beneteau Oceanis 38",
    tier: "Base",
    status: "Awaiting approval",
    location: "La Rochelle, FR",
    price: "€210,000",
    length: "38 ft",
    year: 2017,
    summary: "Well-kept cruiser awaiting final vetting and document checks.",
  },
];

export const messages: Message[] = [
  {
    id: "m1",
    listingId: "lagoon-42",
    sender: "Alex",
    email: "buyer@example.com",
    body: "Can we schedule a video tour this week?",
    status: "delivered",
    notifiedAt: "1h ago",
    readAt: null,
  },
  {
    id: "m2",
    listingId: "axopar-37",
    sender: "Maria",
    email: "sea@gmail.com",
    body: "Confirm engine hours and last service?",
    status: "pending",
    notifiedAt: "3h ago",
    readAt: null,
  },
  {
    id: "m3",
    listingId: "oceanis-38",
    sender: "Jon",
    email: "jon@navy.com",
    body: "Docs uploaded—ready for approval?",
    status: "delivered",
    notifiedAt: "20m ago",
    readAt: "20m ago",
  },
];

export function getListingById(id: string): Listing | undefined {
  return listings.find((l) => l.id === id);
}
